import { useFlag } from '@openfeature/react-sdk';
import { navigateToUrl } from 'single-spa';
import { applications, useCurrentClient } from '@alli/frontend-common';

export const homeCourtFlag = 'home_court_enabled';

export default function Logo({ className, currentUser }) {
    const { value: homeCourtEnabled } = useFlag(homeCourtFlag, false);
    const currentClient = useCurrentClient();

    if (!currentClient) {
        return <LogoSVG className={className} />;
    }

    const targetApp =
        currentUser.type === 'pmg' && homeCourtEnabled
            ? applications.homecourt
            : applications[applications.defaultApplication];

    const targetUrl = applications.renderClientUrl(currentClient, targetApp);

    return (
        <a onClick={navigateToUrl} href={targetUrl}>
            <LogoSVG className={className} />
        </a>
    );
}

function LogoSVG({ className }) {
    return (
        <svg
            className={`text-gray-800 ${className}`}
            viewBox="0 0 37 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Alli Logo"
        >
            <path
                d="M11.0053 11.5456C9.69017 9.86255 7.89057 9.59326 6.85234 9.59326C3.14933 9.59326 0.0346375 12.3198 0.0346375 16.7293C0.0346375 20.4656 2.49178 23.9663 6.81774 23.9663C7.82136 23.9663 9.58635 23.7307 11.0053 22.115V23.5624H14.2584V9.96353H11.0053V11.5456ZM7.23303 21.1388C4.87971 21.1388 3.35697 19.1529 3.35697 16.7966C3.35697 14.3731 4.87971 12.4208 7.23303 12.4208C9.27488 12.4208 11.1783 13.8345 11.1783 16.8303C11.1783 19.6914 9.30949 21.1388 7.23303 21.1388Z"
                className="fill-current"
            />
            <path
                d="M21.6298 0H18.3767V23.5624H21.6298V0Z"
                className="fill-current"
            />
            <path
                d="M29.0012 0H25.7481V23.5624H29.0012V0Z"
                className="fill-current"
            />
            <path
                d="M36.3726 9.96362H33.1195V23.5625H36.3726V9.96362Z"
                className="fill-current"
            />
            <path
                d="M34.746 3.26514C33.5348 3.26514 32.6696 4.14031 32.6696 5.28477C32.6696 6.42923 33.5694 7.30441 34.746 7.30441C35.9573 7.30441 36.8571 6.42923 36.8571 5.28477C36.8571 4.14031 35.9227 3.26514 34.746 3.26514Z"
                className="fill-current"
            />
        </svg>
    );
}
